import './App.css';
import About from './Page/About/About';
import ScrollToTop from './Page/Component/ScrollToTop';
import Contact from './Page/Contact/Contact';
import Home from './Page/Home/Home';
import Work from './Page/Work/Work';
import { BrowserRouter, Routes, Route } from 'react-router-dom'

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/work" element={<Work/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<Contact/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
